module.exports = __webpack_public_path__ + "img/lvvp.3e432ac4.svg";